import { useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { parseWaitlistUtm, storeWaitlistUtm } from '@/utils/waitlist-utm';

/** Stores UTM params from the current URL for the waitlist sign-up. */
const useCaptureWaitlistUtm = () => {
  const searchStr = useRouterState({
    select: (state) => state.location.searchStr,
  });

  useEffect(() => {
    storeWaitlistUtm(parseWaitlistUtm(searchStr));
  }, [searchStr]);
};

export default useCaptureWaitlistUtm;
